import { FC } from 'react';

import { nullNoop } from 'utils/noop';

import { IBonusPointsProps } from './types';

export const BonusPoints = nullNoop as FC<IBonusPointsProps>;
